export default __webpack_public_path__ + "static/media/mockEpic-300.15dc4d60.png";